import React from 'react';
import HeaderComponent from '../../Shared/header.shared';
import FooterComponent from '../../Shared/footer.shared';

const UnauthorizedScreen: React.FC = () => {
  return (
    <>
      <HeaderComponent theme="light" />
      <section className="simple-page page--notfound">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="module text-center">
                <p className="icon-big text-blue400">
                  <span className="material-symbols-outlined">lock</span>
                </p>
                <h1 className="text-blue700">Acceso restringido al Centro de Ayuda SITIC</h1>
                <p className="text-21">
                  Para consultar la información disponible en este sitio es necesario contar con una sesión activa en los sistemas SITIC.
                </p>
                <p className="text-21 mt-3">
                  Por favor, ingrese a través del sistema principal de SITIC y vuelva a intentar el acceso.
                </p>
                <p className="text-21 mt-3">
                  Si después de iniciar sesión el problema persiste, le pedimos contactar al área de soporte para recibir asistencia:
                </p>
                <ul className="text-21 mt-3 list-unstyled">
                  <li className="mb-2">📧 Correo: <a href="mailto:soporte@siticsoftware.com">soporte@siticsoftware.com</a></li>
                  <li>📞 Teléfono: <a href="tel:+(871)2272000">(871) 227 2000</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterComponent />
    </>
  );
};

export default UnauthorizedScreen;


